import axios from 'axios';

const serviceBack = axios.create({
    baseURL: process.env.REACT_APP_BACKEND_URL || 'https://app.dev.pampa4.ar:4000'
    // for development baseURL: 'https://apidev.pampa4.com.ar:4040'
});

serviceBack.defaults.headers.common['x-auth-token'] = null;

serviceBack.setAuth= function (token){
    if(token) {
        serviceBack.defaults.headers.common['x-auth-token'] = token;
    }else {
        delete serviceBack.defaults.headers.common['x-auth-token'];
    }
}

// valido solo para el nuevo login el cual tambien es legacy x-auth-token
serviceBack.setToken= function (token){
    if(token) {
        serviceBack.defaults.headers.common['Authorization'] = 'Bearer '+token;
    }else {
        delete serviceBack.defaults.headers.common['Authorization'];
    }
}


// Example for use 
// serviceBack.get('/statistics/integrators').then.catch

export default serviceBack;